// extracted by mini-css-extract-plugin
module.exports = {"chipsDropdown":"buildChipsDropdownConfig_chipsDropdown__CD9bT","additionalContent":"buildChipsDropdownConfig_additionalContent__6MUSY"};